import React from 'react';

interface Props {
    children: React.ReactNode;
    className?: string;
    columns?: number;
}

const AdaptiveContainer = ({ children, className = "", columns = 2 }: Props) => {
    const gridClass = columns === 2 ? "sm:grid-cols-2" : `sm:grid-cols-${columns}`;

    return (
        <div
            className={`grid grid-cols-1 ${gridClass} gap-4 place-items-center py-4 auto-rows-auto ${className}`}
        >
            {children}
        </div>
    );
};

export default AdaptiveContainer;
